module.exports = __webpack_public_path__ + "e80d58ff824ecb0d9c593162995df69c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-29.png
// module id = 2470
// module chunks = 0